import { IAuditTrailAction, IAuditTrailState } from "../../interfaces";
import { updateObject } from "../../shared/utility";
import { ActionTypes } from "../actions/actionTypes";

type TState = IAuditTrailState;
type TAction = IAuditTrailAction;

const initialState: TState = {
  loading: false,
  auditTrails: null,
  error: null,
};

const listAuditTrailsStart = (state: TState, action: TAction): TState => {
  return updateObject(state, {
    auditTrails: null,
    loading: true,
    error: null,
  });
};

const listAuditTrailsSuccess = (
  state: TState,
  action: TAction
): TState => {
  return updateObject(state, {
    auditTrails: action.auditTrails,
    loading: false,
    error: null,
  });
};

const listAuditTrailsFail = (state: TState, action: TAction): TState => {
  return updateObject(state, {
    loading: false,
    error: action.error,
  });
};

const clearAuditTrail = (state: TState, action: TAction): TState => {
  return { ...initialState };
};

const reducer = (
  state: TState = initialState,
  action: TAction
): TState => {
  switch (action.type) {
    case ActionTypes.AUDIT_TRAIL_LIST_START:
      return listAuditTrailsStart(state, action);
    case ActionTypes.AUDIT_TRAIL_LIST_SUCCESS:
      return listAuditTrailsSuccess(state, action);
    case ActionTypes.AUDIT_TRAIL_LIST_FAIL:
      return listAuditTrailsFail(state, action);
    case ActionTypes.AUDIT_TRAIL_LIST_CLEAR:
      return clearAuditTrail(state, action);
    default:
      return state;
  }
};

export default reducer;
